import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ratingApi } from "../../api/agent/ratingApi";
import { fetchRating } from "../../../../modules/reducers/chat/agent/rating";
import { useNavigate } from "react-router-dom";
import { initChatStatus } from "#src/modules/reducers/chat/agent/connectChatServer.js";

const useRating = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const ticketId = useSelector((state) => state.connectChatServer.ticketId);

  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");

  const handleRating = (value) => {
    setRating(value);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const submitRating = () => {
    const api = ratingApi();
    const data = {
      ticketId,
      rating,
      comment,
    };
    dispatch(fetchRating({ ...api, data }));
    dispatch(initChatStatus());
    navigate("/landing");
  };

  const close = () => {
    dispatch(initChatStatus());
    navigate("/landing");
  };

  return {
    rating,
    handleRating,
    comment,
    handleCommentChange,
    submitRating,
    close,
  };
};

export default useRating;
